import { Link } from "react-router-dom";

import SiteTitle from "./../../../utils/SiteTitle/SiteTitle";
import { baseRoute } from "../../../utils";

const NotFoundPage = ({ isOrgan = false }) => {
  return (
    <>
      <SiteTitle title="صفحه مورد نظر یافت نشد" />

      {/* 404 section start */}
      <div className="d-flex justify-content-center align-items-center ">
        <div className="card my-3">
          <div className="card-body text-center">
            <img src="/assets/images/error-img.png" alt="خطا" />
            <h2>متاسفانه صفحه مورد نظر یافت نشد!</h2>
            <p className="lead">
              ممکن است صفحه مورد نظر حذف شده باشد ، نام آن تغییر کرده یا موقتاً
              در دسترس نباشد.
            </p>
            <Link to={baseRoute(isOrgan, "/")} className="btn btn-primary">
              به صفحه اصلی بروید
            </Link>
          </div>
        </div>
      </div>
      {/* 404 section end */}
    </>
  );
};

export default NotFoundPage;
